<template>
<div>
  <span
    style="display: table-cell; width: 22px">
    <i v-if="availableTransports['arrival'].length"
      class="list-icon material-icons el-button--text rotate90">
      flight
    </i>
  </span>
  <transition
    name="el-zoom-in-top"
    mode="out-in">
    <span v-if="Object.keys(arrivalTransport).length"
      :key="arrivalTransport.id"
      style="display: table-cell; vertical-align:middle;">
      {{ arrivalTransport | arrivalString(_self) }}
    </span>
  </transition>
  <i v-if="availableTransports['return'].length"
    class="list-icon material-icons el-button--text rotate270">
    flight
  </i>
  <transition
    name="el-zoom-in-top"
    mode="out-in">
    <div v-if="Object.keys(returnTransport).length"
      :key="returnTransport.id"
      class="list-icon">
      {{ returnTransport | returnString(_self) }}
    </div>
  </transition>
  <div style="clear:both;"></div>
   <i
    class="list-icon material-icons el-button--text">
    group
  </i>
  <transition
    name="el-zoom-in-top"
    mode="out-in">
    <div
      :key="totalCountTravelers"
      class="list-icon">
      {{ totalTravelers | travelersString(_self) }}
    </div>
  </transition>
  <div style="clear:both;"></div>
  <i
    class="list-icon material-icons el-button--text">
    date_range
  </i>
  <transition
    name="el-zoom-in-top"
    mode="out-in">
    <div
      :key="object.ibeData.dateFrom + object.ibeData.dateTo"
      class="list-icon">
      {{ object.ibeData.dateFrom | dateFormat(_self) }} - {{ object.ibeData.dateTo | dateFormat(_self) }}
    </div>
  </transition>
  <div style="clear:both;"></div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ListIcons',
  computed: {
    ...mapGetters('booking', [
      'appControl',
      'object',
      'totalTravelers',
      'totalCountTravelers',
      'availablePrograms',
      'availableTransports',
      'arrivalTransport',
      'returnTransport'
    ])
  },
  watch: {
    arrivalTransport () {
      if (Object.keys(this.arrivalTransport).length && this.arrivalTransport.ibeData.dateFrom !== this.arrivalTransport.ibeData.dateTo) {
        let stopover = this.availablePrograms.stopovers && this.availablePrograms.stopovers.length ? this.availablePrograms.stopovers[0] : null
        let options = {
          title: this.$t(stopover ? 'ibe.headline_info_stopover' : 'ibe.headline_info_diffDateFrom'),
          message: this.$t('ibe.text_info_diffDateFrom'),
          duration: this.appControl.timeouts.diffDateFromNotify
        }
        if (stopover) {
          let nights = Math.round((new Date(stopover.ibeData.dateTo) - new Date(stopover.ibeData.dateFrom)) / 86400000)
          options.message = this.$t('ibe.text_info_stopover') +
            '<br><br>' + stopover.text.name +
            '<br>' + this.$t('ibe.label_stopover_stay') + ': ' + nights + ' ' + this.$tc('ibe.nights', nights)
          options.dangerouslyUseHTMLString = true
          options.customClass = 'stopover-notify'
        }
        this.$notify.info(options)
      }
    },
    returnTransport () {
      if (Object.keys(this.returnTransport).length && this.returnTransport.ibeData.dateFrom !== this.returnTransport.ibeData.dateTo) {
        this.$notify.info({
          title: this.$t('ibe.headline_info_diffDateTo'),
          message: this.$t('ibe.text_info_diffDateTo'),
          duration: this.appControl.timeouts.diffDateToNotify
        })
      }
    }
  }
}
</script>
